import {applyMiddleware, combineReducers, createStore} from "redux";
import thunkMiddleware from "redux-thunk"
import tableReducer from "./content-reducer";
import dropdownsReducer from "./format-reducer";

let reducers = combineReducers({
    dropdownsReducer: dropdownsReducer,
    contentData: tableReducer
});

let store = createStore(reducers, applyMiddleware(thunkMiddleware));

window.store = store;


export default store;